import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ConsumerLanding from "@/pages/ConsumerLanding";
import ConsumerGrid from "@/pages/ConsumerGrid";
import MerchantPortal from "@/pages/MerchantPortal";
import AdminDashboard from "@/pages/AdminDashboard";
import Login from "@/pages/Login";
import AdminLogin from "@/pages/AdminLogin";
import SalesRepDashboard from "@/pages/SalesRepDashboard";
import MerchantCreative from "@/pages/MerchantCreative";
import { RoleGuard } from "@/components/RoleGuard";
import Validate from "@/pages/Validate";
import SponsorView from "@/pages/SponsorView";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<ConsumerLanding />} />
            <Route path="/deals/:campaignId" element={<ConsumerGrid />} />
            <Route path="/sponsor" element={<MerchantPortal />} />
            <Route path="/sponsors" element={<MerchantPortal />} />
            <Route path="/merchant" element={<MerchantPortal />} />
            <Route path="/partner" element={<MerchantPortal />} />
            <Route path="/sponsor/:campaignId" element={<SponsorView />} />
            <Route path="/sponsors/:campaignId" element={<SponsorView />} />

            <Route path="/login" element={<Login />} />
            <Route path="/partner-login" element={<Login />} />
            <Route path="/partner/dashboard" element={<RoleGuard role="merchant" redirect="/login"><MerchantPortal /></RoleGuard>} />
            <Route path="/sales/dashboard" element={<RoleGuard role="sales_rep" redirect="/login"><SalesRepDashboard /></RoleGuard>} />

            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<RoleGuard role="admin" redirect="/admin"><AdminDashboard /></RoleGuard>} />

            <Route path="/validate/:slotId" element={<Validate />} />
            <Route path="/creative/:token" element={<MerchantCreative />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
